import React, { useState, useEffect } from 'react';
import DemoTestBox from '../../tool/boxes/DemoTestBox';
import LandingHeader from '../LandingHeader';
import LandingFooter from '../LandingFooter';
import './DemoPage.css';

const DemoPage = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1600);
    const [isPortrait, setIsPortrait] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            const isMobileDevice = width < 768;
            const isPortraitMode = height > width;
            
            setIsSmallScreen(width < 1600);
            setIsMobile(isMobileDevice);
            setIsPortrait(isMobileDevice && isPortraitMode);
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const RotationMessage = () => (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '60vh',
            textAlign: 'center',
            padding: '2rem'
        }}>
            <div style={{
                fontSize: '3rem',
                marginBottom: '2rem',
                color: 'var(--blue)',
                transform: 'rotate(270deg)'
            }}>
                <i className="fas fa-mobile-alt"></i>
            </div>
            <h2 style={{
                fontSize: '1.5rem',
                marginBottom: '1rem',
                color: 'var(--black)'
            }}>
                Please Rotate Your Device
            </h2>
            <p style={{
                fontSize: '1rem',
                color: '#666',
                maxWidth: '300px',
                lineHeight: '1.5'
            }}>
                The demo requires a landscape orientation for the best experience. Please rotate your device to continue.
            </p>
        </div>
    );

    return (
        <div className="demo-page">
            <LandingHeader page="demo" />
            <main className="demo-content">
                {/* DemoTestBox is always rendered but hidden via CSS on mobile portrait */}
                <div 
                    className={isMobile && isPortrait ? 'demo-hidden' : ''}
                    style={isMobile && isPortrait ? { display: 'none' } : {}}
                >
                    <DemoTestBox 
                        key="demo-test-box" 
                        isSmallScreen={isSmallScreen} 
                    />
                </div>
                
                {/* Rotation message only shows on mobile portrait */}
                {isMobile && isPortrait && <RotationMessage />}
            </main>
            <LandingFooter />
        </div>
    );
};

export default DemoPage; 